import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';
import FieldComponent from '../FieldComponent/FieldComponent';
import FieldFile from "../FieldFile/FieldFile";

export default class FieldCheckAndUpload extends FieldComponent {

    constructor(props) {
        super(props);

        this.state.value = (this.props.option.value === true) ? true : false;
        this.state.hasFile = (this.props.option.hasFile === true) ? true : false;
        this.state.file = null;

        this.ui_file = React.createRef();

        this.setHasFile = this.setHasFile.bind(this);
        this.getFile = this.getFile.bind(this);
        this.onChooseFile = this.onChooseFile.bind(this);
        this.onDeleteFile = this.onDeleteFile.bind(this);
    }

    setHasFile(hasFile) {
        this.setState({hasFile});
    }

    getFile() {
        const {hasFile, file} = this.state;
        return {
            hasFile,
            file,
        };
    }

    onChooseFile() {
        let file = this.ui_file.current.getValue();
        this.setState({file, hasFile: true});
    }

    onDeleteFile() {
        this.setState({file: null, hasFile: false});
    }

    render() {
        const {value, hasFile} = this.state;

        return (
            <div className="field-wrap">
                <div className="fb-col">
                    <div className="fb-row fb-s-c">
                        <input id={this.labelId} ref={this.ui} type="checkbox"
                               onChange={e => this.onChange(e.currentTarget.checked)} onKeyPress={this.onKeyPress}
                               checked={value} disabled={!this.state.enabled}/>
                        {this.props.option.label &&
                        <label htmlFor={this.labelId}
                               className="label">{i18n(this.props.option.label, this.props.setting.lang)}</label>
                        }
                    </div>
                    <div className="help">{i18n(this.props.option.help, this.props.setting.lang)}</div>
                </div>
                {value && (
                    !hasFile ? (
                            <div className='fb-row fb-s-e'>
                                <FieldFile ref={this.ui_file} setting={this.props.setting} option={{
                                    onChange: this.onChooseFile,
                                }}>
                                    <div
                                        className='btn btn-primary w100 m50rem'>{i18n('VERB_UPLOAD_DOCUMENT', this.props.setting.lang)}</div>
                                </FieldFile>
                            </div>
                        )
                        :
                        (
                            <div
                                className='btn btn-danger w100 m50rem'
                                onClick={this.onDeleteFile}>{i18n('VERB_DELETE_DOCUMENT', this.props.setting.lang)}</div>
                        )
                )
                }

            </div>
        );
    }

}